import Entities from './Entities'

export default ({ getRoles, addRole, setWriteAccess, removeRole }) ->
  Entities({
    addEntity: addRole
    allEntities: ->
      _.filter(await Weaver.Role.list(), ['_isDomain', false])
    entityFilter: (value, role) ->
      role.name().toLowerCase().includes(value.toLowerCase())
    comparator: (role) -> role.id()
    sortBy: (role) -> role.name()
    getEntities: getRoles
    removeEntity: removeRole
    setWriteAccess: setWriteAccess
    title: 'groups'
    titleRenderer: (item) -> item.name()
  })
